<template>
  <div>
    <v-row
      justify="end"
      class="mt-2 mb-3"
    >
      <v-col cols="auto">
        <v-btn
          class="common-botton"
          dark
          :disabled="disabled"
          @click="abrirConfirmacionRedencionMasiva"
        >
          <v-icon class="mr-2">
            mdi-checkbox-multiple-marked
          </v-icon>

          Redimir solicitudes

          <span
            v-if="cantidadSeleccionadas > 0"
            class="ml-1"
          >
            ({{ cantidadSeleccionadas }})
          </span>
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showConfirmacionRedencionMasiva"
      max-width="520"
      persistent
    >
      <v-card>
        <v-card-title>
          Confirmar redención masiva
        </v-card-title>

        <v-card-text>
          Se procesarán

          <strong>
            {{ cantidadSeleccionadas }}
          </strong>

          solicitudes.

          <div
            v-if="seleccionarTodas"
            class="mt-3"
          >
            Se seleccionaron todas las solicitudes
            del filtro actual.

            <span v-if="idsExcluidos.length">
              Se excluirán
              {{ idsExcluidos.length }}.
            </span>
          </div>

          <div
            v-else
            class="mt-3"
          >
            Se procesarán únicamente las solicitudes
            seleccionadas manualmente.
          </div>

          <div class="mt-3">
            Una vez iniciado, cada solicitud será
            enviada al flujo normal de redención.
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            text
            @click="
              showConfirmacionRedencionMasiva = false
            "
          >
            Cancelar
          </v-btn>

          <v-btn
            class="common-botton"
            dark
            @click="confirmarRedencionMasiva"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showProgresoRedencionMasiva"
      max-width="650"
      persistent
    >
      <v-card>
        <v-card-title>
          Redención masiva de beneficios
        </v-card-title>

        <v-card-text>
          <v-progress-linear
            :value="progresoRedencionMasiva.porcentaje"
            height="22"
            rounded
          >
            <strong>
              {{
                progresoRedencionMasiva.porcentaje
              }}%
            </strong>
          </v-progress-linear>

          <div class="mt-4">
            Procesadas:

            <strong>
              {{ progresoRedencionMasiva.procesadas }}
            </strong>

            /

            <strong>
              {{
                progresoRedencionMasiva.total ||
                totalObjetivoRedencionMasiva
              }}
            </strong>
          </div>

          <div
            v-if="
              progresoRedencionMasiva.solicitudActual
            "
            class="mt-2"
          >
            Solicitud actual:

            <strong>
              {{
                progresoRedencionMasiva
                  .solicitudActual
              }}
            </strong>
          </div>

          <div class="mt-2">
            {{
              progresoRedencionMasiva.mensaje ||
              "Preparando proceso..."
            }}
          </div>

          <div
            v-if="redencionFinalizada"
            class="mt-4"
          >
            <strong>
              Redimidas:
              {{
                progresoRedencionMasiva
                  .totalRedimidas
              }}
            </strong>

            <br />

            <strong>
              Errores:
              {{
                progresoRedencionMasiva
                  .totalErrores
              }}
            </strong>
          </div>

          <div
            v-if="historialRedencionMasiva.length"
            class="mt-4"
          >
            <strong>
              Actividad
            </strong>

            <div
              style="
                max-height: 220px;
                overflow-y: auto;
                margin-top: 8px;
              "
            >
              <div
                v-for="(evento, index) in historialRedencionMasiva"
                :key="index"
                class="mb-2"
              >
                <strong
                  v-if="evento.solicitudActual"
                >
                  Solicitud {{ evento.solicitudActual }}:
                </strong>

                {{ evento.mensaje }}
              </div>
            </div>
          </div>

          <div
            v-if="erroresRedencionMasiva.length"
            class="mt-4"
          >
            <strong>
              Errores encontrados
            </strong>

            <div
              style="
                max-height: 180px;
                overflow-y: auto;
                margin-top: 8px;
              "
            >
              <div
                v-for="(error, index) in
                  erroresRedencionMasiva"
                :key="index"
                class="mb-2"
              >
                <strong
                  v-if="error.solicitudActual"
                >
                  Solicitud
                  {{ error.solicitudActual }}:
                </strong>

                {{ error.mensaje }}
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="procesandoRedencionMasiva"
            text
            :loading="deteniendoRedencionMasiva"
            :disabled="
              !procesoIdRedencionMasiva ||
              deteniendoRedencionMasiva
            "
            @click="detenerProcesoRedencionMasiva"
          >
            Detener proceso
          </v-btn>

          <v-spacer />

          <v-btn
            v-if="!procesandoRedencionMasiva"
            class="common-botton"
            dark
            @click="cerrarProgresoRedencionMasiva"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  redimirSolicitudesMasivamenteSSE,
  detenerRedencionMasiva,
} from "@/services/redencionMasivaService";

export default {
  name: "RedencionMasivaDialog",

  props: {
    cantidadSeleccionadas: {
      type: Number,
      default: 0,
    },

    seleccionarTodas: {
      type: Boolean,
      default: false,
    },

    idsExcluidos: {
      type: Array,
      default: () => [],
    },

    payload: {
      type: Object,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showConfirmacionRedencionMasiva: false,
      showProgresoRedencionMasiva: false,

      procesandoRedencionMasiva: false,
      deteniendoRedencionMasiva: false,
      redencionFinalizada: false,
      redencionDetenidaPorUsuario: false,

      procesoIdRedencionMasiva: null,
      totalObjetivoRedencionMasiva: 0,

      progresoRedencionMasiva: {
        procesadas: 0,
        total: 0,
        porcentaje: 0,
        solicitudActual: null,
        mensaje: "",
        tipo: "info",
        totalRedimidas: 0,
        totalErrores: 0,
      },

      erroresRedencionMasiva: [],
      historialRedencionMasiva: [],
    };
  },

  methods: {
    abrirConfirmacionRedencionMasiva() {
      if (this.disabled) {
        return;
      }

      this.showConfirmacionRedencionMasiva = true;
    },

    reiniciarEstadoProcesoRedencionMasiva() {
      this.procesoIdRedencionMasiva = null;

      this.procesandoRedencionMasiva = false;
      this.deteniendoRedencionMasiva = false;
      this.redencionFinalizada = false;
      this.redencionDetenidaPorUsuario = false;

      this.progresoRedencionMasiva = {
        procesadas: 0,
        total: 0,
        porcentaje: 0,
        solicitudActual: null,
        mensaje: "",
        tipo: "info",
        totalRedimidas: 0,
        totalErrores: 0,
      };

      this.erroresRedencionMasiva = [];
      this.historialRedencionMasiva = [];
    },

    async confirmarRedencionMasiva() {
      const payload = {
        ...this.payload,
      };

      this.totalObjetivoRedencionMasiva =
        this.cantidadSeleccionadas;

      this.showConfirmacionRedencionMasiva = false;

      this.reiniciarEstadoProcesoRedencionMasiva();

      this.procesandoRedencionMasiva = true;
      this.showProgresoRedencionMasiva = true;

      try {
        await redimirSolicitudesMasivamenteSSE(
          payload,
          this.manejarEventoRedencionMasiva
        );

        if (!this.redencionFinalizada) {
          this.redencionFinalizada = true;

          const huboErrores =
            this.erroresRedencionMasiva.length > 0;

          if (huboErrores) {
            this.progresoRedencionMasiva.totalErrores =
              this.erroresRedencionMasiva.length;

            this.progresoRedencionMasiva.mensaje =
              "Proceso detenido por un error crítico";

            this.progresoRedencionMasiva.tipo =
              "error";
          } else {
            this.progresoRedencionMasiva.mensaje =
              "El proceso finalizó.";
          }
        }
      } catch (error) {
        console.error(
          "Error en redención masiva:",
          error
        );

        this.redencionFinalizada = true;

        this.progresoRedencionMasiva.mensaje =
          error.message ||
          "Ocurrió un error durante la redención masiva";

        this.progresoRedencionMasiva.tipo =
          "error";

        this.erroresRedencionMasiva.push({
          solicitudActual: null,
          mensaje:
            this.progresoRedencionMasiva.mensaje,
        });
      } finally {
        this.procesandoRedencionMasiva = false;
        this.deteniendoRedencionMasiva = false;

        this.$emit("finalizado");
      }
    },

    manejarEventoRedencionMasiva(
      nombreEvento,
      data
    ) {
      if (nombreEvento === "init") {
        this.procesoIdRedencionMasiva =
          data.procesoId;

        return;
      }

      if (nombreEvento === "progreso") {
        this.progresoRedencionMasiva = {
          ...this.progresoRedencionMasiva,

          procesadas:
            data.procesadas !== undefined
              ? data.procesadas
              : this.progresoRedencionMasiva
                  .procesadas,

          total:
            data.total !== undefined
              ? data.total
              : this.progresoRedencionMasiva.total,

          porcentaje:
            data.porcentaje !== undefined
              ? data.porcentaje
              : this.progresoRedencionMasiva
                  .porcentaje,

          solicitudActual:
            data.solicitudActual !== undefined
              ? data.solicitudActual
              : this.progresoRedencionMasiva
                  .solicitudActual,

          mensaje:
            data.mensaje ||
            this.progresoRedencionMasiva.mensaje,

          tipo:
            data.tipo ||
            this.progresoRedencionMasiva.tipo,
          
        };

        if (data.mensaje) {
          this.historialRedencionMasiva.push({
            solicitudActual: data.solicitudActual,
            mensaje: data.mensaje,
            tipo: data.tipo || "info",
          });
        }

        if (data.tipo === "error") {
          this.erroresRedencionMasiva.push({
            solicitudActual:
              data.solicitudActual,
            mensaje: data.mensaje,
          });
        }

        return;
      }

      if (nombreEvento === "completado") {
        const fueDetenido =
          this.redencionDetenidaPorUsuario;

        this.progresoRedencionMasiva = {
          ...this.progresoRedencionMasiva,

          porcentaje: fueDetenido
            ? this.progresoRedencionMasiva.porcentaje
            : 100,

          totalRedimidas:
            data.totalRedimidas || 0,

          totalErrores:
            data.totalErrores || 0,

          mensaje: fueDetenido
            ? "Proceso detenido por el usuario"
            : data.mensaje ||
              "Proceso completado",

          tipo: fueDetenido
            ? "warning"
            : data.tipo || "success",
        };

        this.redencionFinalizada = true;
        this.procesandoRedencionMasiva = false;

        return;
      }

      if (nombreEvento === "error") {
        const mensaje =
          data && data.mensaje
            ? data.mensaje
            : "El proceso fue detenido por un error";

        this.progresoRedencionMasiva.mensaje =
          mensaje;

        this.progresoRedencionMasiva.tipo =
          "error";

        this.erroresRedencionMasiva.push({
          solicitudActual:
            data && data.solicitudActual
              ? data.solicitudActual
              : null,

          mensaje,
        });

        this.redencionFinalizada = true;
        this.procesandoRedencionMasiva = false;
      }
    },

    async detenerProcesoRedencionMasiva() {
      if (!this.procesoIdRedencionMasiva) {
        this.$toast.warning(
          "El proceso todavía no tiene un identificador"
        );

        return;
      }

      try {
        this.deteniendoRedencionMasiva = true;

        this.redencionDetenidaPorUsuario = true;

        const response =
          await detenerRedencionMasiva(
            this.procesoIdRedencionMasiva
          );

        this.progresoRedencionMasiva.mensaje =
          response.mensaje ||
          "Proceso detenido por el usuario";

      } catch (error) {
        console.error(
          "Error al detener redención masiva:",
          error
        );

        this.redencionDetenidaPorUsuario = false;

        this.$toast.error(
          "No fue posible detener el proceso"
        );

        this.deteniendoRedencionMasiva = false;
      }
    },

    cerrarProgresoRedencionMasiva() {
      if (this.procesandoRedencionMasiva) {
        return;
      }

      this.showProgresoRedencionMasiva = false;
    },
  },
};
</script>